PJQ.models.customFields = {};
PJQ.collections.customFields = {};
PJQ.views.customFields = {};

PJQ.helpers.customFieldHelpers = {
    getDisplayValue: function (type, value, choices = null, isMultipleChoice = false) {
        // currently only supports choices being a backbone collection
        if (type == null || value == null || (type === 'CHOICE' && _.size(choices) === 0)) {
            return '';
        }
        let typeUpper = type.toUpperCase(),
            valueType = PJQ.helpers.objectHelpers.refinedType(value),
            result = '';
        switch (typeUpper) {
            case PJQ.constants.customFields.fieldTypes.TEXT:
                if (valueType === 'string') {
                    result = value;
                } else if (valueType === 'number') {
                    result = valueType.toString();
                }
                break;
            case PJQ.constants.customFields.fieldTypes.CHOICE:
                let fnGetChoiceName = function (choiceId) {
                    if (choiceId == null) {
                        return '';
                    }
                    let chId;
                    if (typeof choiceId === 'number') {
                        chId = choiceId;
                    } else if (typeof choiceId === 'string') {
                        if (_.size(choiceId) === 0) {
                            return '';
                        }
                        chId = parseInt(choiceId);
                        if (isNaN(chId)) {
                            return '';
                        }
                    }
                    let choice = choices.get(chId);
                    if (choice != null) {
                        if (_.size(choice.get('value')) > 0) {
                            return choice.get('value');
                        } else if (_.size(choice.get('name')) > 0) {
                            return choice.get('name');
                        }
                    }
                    return '';
                }
                if (isMultipleChoice) {
                    let arrValue;
                    if (valueType === 'array') {
                        arrValue = value;
                    } else if (valueType === 'string') {
                        arrValue = value.split('|');
                    } else {
                        arrValue = [];
                    }

                    let choiceNames = [];
                    _.each(arrValue, function (choiceId) {
                        let choiceName = fnGetChoiceName(choiceId);
                        if (_.size(choiceName) > 0) {
                            choiceNames.push(choiceName);
                        }
                    })
                    result = choiceNames.join(', ');
                } else {
                    let choiceId;
                    if (valueType === 'number') {
                        choiceId = value;
                    } else if (valueType === 'string') {
                        choiceId = parseInt(value);
                    } else {
                        choiceId = null;
                    }
                    result = choiceId == null ? '' : fnGetChoiceName(choiceId);
                }
                break;
            case PJQ.constants.customFields.fieldTypes.BOOL:
                let boolValue;
                if (valueType === 'boolean') {
                    boolValue = value;
                } else if (valueType === 'string') {
                    if (_.size(value) === 0) {
                        return '';
                    }
                    let lowerValue = value.toLowerCase();
                    boolValue = lowerValue === 'true' || lowerValue === 'yes';
                } else if (valueType === 'number') {
                    boolValue = value === 1;
                } else {
                    boolValue = null;
                }
                if (boolValue == null) {
                    result = '';
                } else {
                    result = boolValue ? 'Yes' : 'No';
                }
                break;
            case PJQ.constants.customFields.fieldTypes.INT:
            case PJQ.constants.customFields.fieldTypes.MONEY:
            case PJQ.constants.customFields.fieldTypes.PERCENT:
                let intValue;
                if (valueType === 'number') {
                    intValue = value;
                } else if (valueType === 'string') {
                    intValue = parseInt(value);
                } else {
                    intValue = null;
                }

                if (intValue == null || isNaN(intValue)) {
                    result = '';
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.INT) {
                    result = intValue.toString();
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.MONEY) {
                    result = PJQ.helpers.formatHelpers.formatCurrency(intValue)
                } else if (typeUpper === PJQ.constants.customFields.fieldTypes.PERCENT) {
                    result = intValue.toString() + '%';
                }
                break;
            case PJQ.constants.customFields.fieldTypes.DATE:
            case PJQ.constants.customFields.fieldTypes.DATETIME:
                let dateValue;
                if (valueType === 'date') {
                    dateValue = value;
                } else if (valueType === 'string') {
                    dateValue = new Date(value);
                } else {
                    dateValue = null;
                }

                let isDateTime = typeUpper === PJQ.constants.customFields.fieldTypes.DATETIME,
                    format;
                if (isDateTime) {
                    format = PJQ.helpers.dateHelpers.dateFormats.DATE_TIME;
                } else {
                    format = PJQ.helpers.dateHelpers.dateFormats.DATE;
                }
                result = dateValue == null ? '' : PJQ.helpers.dateHelpers.getDateString(dateValue, format, !isDateTime);
                break;
            default:
                result = value;
        }
        return result;
    }
}


//Models
PJQ.models.customFields.CustomField = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    collectionClass: function () {
        return PJQ.collections.customFields.CustomFieldChoices;
    },
    newChoiceCollection: function (choices) {
        return new (this.collectionClass())(choices);
    },
    parse: function (model) {
        if (model != null) {
            if (model.choices != null) {
                if (this.choices != null) {
                    this.choices.reset(model.choices);
                } else {
                    this.choices = this.newChoiceCollection(model.choices);
                    this.choices.on('update', _.bind(function () {
                        this.isDirty = true;
                    }, this));
                }
            } else {
                this.choices = this.newChoiceCollection();
                this.choices.on('update', _.bind(function () {
                    this.isDirty = true;
                }, this));
            }
        } else {
            this.choices = this.newChoiceCollection();
            this.choices.on('update', _.bind(function () {
                this.isDirty = true;
            }, this));
        }

        return model;
    },
    beforeSave: function () {
        this.set('choices', this.choices.getChangedModels());
    }
});

PJQ.models.customFields.CustomFieldChoice = PJQ.models.BaseModel.extend({
    idAttribute: "id"
});


//Collections
PJQ.collections.customFields.CustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.customFields.CustomField
});

PJQ.collections.customFields.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.customFields.CustomFieldChoice
});


//Views
PJQ.views.customFields.CustomFieldsForm = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form'),
        subTemplates: {
            field: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form-Field-Input')
        },
        isEdit: null, // null by default, will be used to seet canEdit if not null
        canEdit: true
    },
    beforeFirstRender: function () {
        if (this.options.isEdit != null) {
            this.options.canEdit = this.options.isEdit;
        }

        this.changedValues = [];
        if (this.options.fieldValues == null) {
            this.options.fieldValues = [];
        }

        if(this.options.applyDefaults !== false){
            _.each(this.collection.models, (field, index) => {
                let value = field.get('defaultValue') ?? '';
                if (field.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE || field.get('fieldType') === PJQ.constants.customFields.fieldTypes.INT) {
                    value = parseInt(value);

                    if (isNaN(value)) {
                        value = null;
                    }
                }

                let existingFieldValue = _.find(this.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === field.get('id');
                });
                value = value != null ? value : null;
                if (value == null) {
                    return;
                }

                if (existingFieldValue == null) {
                    this.options.fieldValues.push({
                        fieldNumber: field.get('fieldNumber'),
                        fieldTypeId: field.get('fieldTypeId'),
                        fieldType: field.get('fieldType'),
                        isMultiple: field.get('isMultiple'),
                        value: value,
                        id: field.get('id')
                    })
                } else if (existingFieldValue.value == null) {
                    existingFieldValue.value = value;
                }
            });
        }
    },
    afterRender: function () {
        _.each(_.sortBy(this.collection.models, function (model) {
            return model.get('sortOrder') != null ? model.get('sortOrder') : model.id
        }), function (field) {
            // Don't render anything for Upload V2 fields
            if (field.get('fieldTypeId') === 13) {
                return;
            }

            if ((field instanceof PJQ.models.contacts.ContactCustomField || field instanceof PJQ.models.contacts.CompanyCustomField) && field.get('isVisibleInRSVP') === false && !this.options.isAdmin) {
                return false;
            }

            let $cf = this.$('.custom-field-outer-' + field.id.toString()),
                $field = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.field, {
                    model: field,
                    fieldValues: this.options.fieldValues,
                    subTemplates: this.options.subTemplates,
                    canEdit: this.options.canEdit,
                    isAdmin: this.options.isAdmin
                });
            if (_.size($cf) > 0) {
                let colClasses = $cf.data('classes');
                $cf.replaceWith($field);
                if (_.size(colClasses) > 0) {
                    $field.removeClass('col-sm-12 col-md-6 col-6 col-12').addClass(colClasses);
                }
            } else {
                this.$('.custom-fields').append($field);
            }
        }, this);
        this.attachFormEvents();
    },
    attachFormEvents: function () {
        let self = this;
        this.customFieldControls = [];

        this.$('.custom-field.input-text[data-p-bind],.custom-field.input-dollars-full[data-p-bind],.custom-field.input-numeric[data-p-bind],.custom-field.input-percent[data-p-bind],.custom-field.input-phone[data-p-bind],.custom-field.input-textarea[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                mask = input.data('mask');
            if (_.size(mask) > 0) {
                input.inputmask(mask, {
                    placeholder: ''
                });
            } else if (input.hasClass('input-dollars-full')) {
                PJQ.helpers.inputHelpers.inputMaskCurrency(input, 2);
            } else if (input.hasClass('input-numeric')) {
                PJQ.helpers.inputHelpers.inputMaskInteger(input);
            } else if (input.hasClass('input-percent')) {
                PJQ.helpers.inputHelpers.inputMaskPercent(input, 2, true);
            } else if (input.hasClass('input-phone')) {
                PJQ.helpers.inputHelpers.inputMaskPhone(input);
            }

            self.customFieldControls.push({
                id: customFieldId,
                input: input
            });
        });

        this.$('.custom-field.input-select[data-p-bind],.custom-field.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                control = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state'),
                    onChange: function (value) {
                        if (input.hasClass('input-bool'))
                            value = value.toLowerCase() === 'true';
                        self.fieldChanged(customFieldId, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-date[data-p-bind],.custom-field.input-date-time').each(function () {
            let input = $(this),
                customFieldId = input.data('fieldId'),
                isDateTime = input.hasClass('input-date-time'),
                control = new PJQ.inputs.Datepicker({
                    el: input,
                    isUTC: false,
                    datepickerOptions: {
                        format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                    },
                    onChange: function (value) {
                        if (!isDateTime)
                            value = PJQ.helpers.dateHelpers.getDateString(value, PJQ.helpers.dateHelpers.dateFormats.DATE);

                        self.fieldChanged(customFieldId, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-contact[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            let value = fieldValue.value,
                isMultipleChoice = input.data('multipleChoice');
            if (isMultipleChoice) {
                value = new PJQ.collections.contacts.Contacts(value).models;
            } else if (value != null) {
                value = new PJQ.models.contacts.Contact(value);
            }

            let control = new PJQ.views.contacts.ContactsSelectInput({
                el: input,
                context: PJQ.constants.contacts.contexts.CONTACTS,
                selectedContact: value,
                isSingleChoice: !isMultipleChoice,
                isReadOnly: !self.options.canEdit,
                emptyNotice: "No Contact Selected",
                onChange: function (selectedContacts) {
                    self.fieldChanged(customFieldId, selectedContacts);
                }
            });

            self.customFieldControls.push({
                id: customFieldId,
                input: control
            });
        });

        this.$('.custom-field.input-html[data-p-bind]').each(function () {
            let $htmlInput = $(this);
            let customFieldId = $htmlInput.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });
            new PJQ.inputs.HTMLEditor({
                el: $htmlInput,
                editorHeight: 600,
                defaultValue: _.size(fieldValue.value) > 0 ? fieldValue.value.replace(/(?:\r\n|\r|\n)/g, '<br>') : fieldValue.value,
                onChange: function (contents) {
                    if (contents !== fieldValue.value) {
                        self.fieldChanged(customFieldId, contents);
                    }
                }
            });
        });

        this.$('.custom-field.file-upload-field').each(function () {

            let endpoint,
                fnInput = function ($input, attachments, endpoint) {
                    let sortSettings;
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SORT_USER_ATTACHMENTS))
                        sortSettings = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SORT_USER_ATTACHMENTS);

                    let uploader = new PJQ.views.files.FileUploaderGrid({
                        el: $input,
                        canUpload: self.options.canEdit,
                        canDelete: self.options.canEdit,
                        collection: attachments,
                        endpoint: endpoint,
                        sortBy: sortSettings ? sortSettings.sortBy : null,
                        sortDirection: sortSettings ? (sortSettings.sortBy ? 'asc' : 'desc') : null,
                        onSuccess: function (file) {
                            let guids = [file.guid];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0) {
                                        guids.push(attachment.get('guid'));
                                    }
                                });
                            }
                            self.fieldChanged($input.data('pBind'), _.uniq(guids).join('|'));
                        },
                        onDelete: function (file, callback) {
                            let guids = [],
                                delAttachments = [];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0 && file.get('guid') !== attachment.get('guid')) {
                                        guids.push(attachment.get('guid'));
                                    } else {
                                        delAttachments.push(attachment);
                                    }
                                });
                                attachments.remove(delAttachments);
                            }
                            self.fieldChanged($input.data('pBind'), _.uniq(guids).join('|'));
                            callback();
                        }
                    });

                    self.customFieldControls.push({
                        id: customFieldId,
                        input: uploader
                    });

                }

            if (self.options.model instanceof PJQ.models.users.User) {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'attachments'
                    }
                ]);
            }

            let $input = $(this);
            let customFieldId = $input.data('pBind'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            if (fieldValue && _.size(fieldValue.value) > 0) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'details'
                        }
                    ]),
                    data: {
                        guids: fieldValue.value ? ((typeof fieldValue.value === 'string') ? fieldValue.value.split('|') : fieldValue.value) : null
                    }
                }).post().done(_.bind(function (result) {
                    let attachments = new PJQ.collections.files.Files(result);
                    fnInput($input, attachments, endpoint);
                }, this));
            } else {
                fnInput($input, new PJQ.collections.files.Files(), endpoint);
            }
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, null, {
            watchElements: [
                'input.custom-field',
                'textarea.custom-field'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                if (changeEl.hasClass('input-date-time') || changeEl.hasClass('input-date'))
                    return;

                this.fieldChanged(parseInt(attribute), value);
            }, this)
        });
    },
    renderField: function (field) {
        // right now we only re-render if its a readonly alert
        let $alert = this.$('.alert[data-field-id="' + field.id.toString() + '"]');
        if (_.size($alert) > 0) {
            let $inputOuter = $alert.closest('.input-outer'),
                fieldValue = _.findWhere(this.options.fieldValues, {id: field.id});
            $inputOuter.children(':not(label)').remove();
            this.renderSubTemplate(true, this.options.subTemplates.fieldInput, $inputOuter, {
                model: field,
                fieldValue: fieldValue != null ? fieldValue.value : null,
                canEdit: typeof field.get('isChangeableInRSVP') === 'undefined' ? this.options.canEdit : ((this.options.canEdit && field.get('isChangeableInRSVP')) || (this.options.canEdit && this.options.isAdmin))
            });
        }
    },
    setValue: function (fieldId, value) {
        this.fieldChanged(fieldId, value, false);

        let field = this.collection.get(fieldId),
            control = _.find(this.customFieldControls, function (control) {
                return control.id === fieldId;
            });

        if (control != null) {
            let fieldType = field.get('fieldType').toLowerCase();
            switch (fieldType) {
                case 'choice':
                    control.input.setValue(value);
                    break;
                case 'money':
                    control.input.val(value / 100);
                    break;
                case 'text':
                case 'int':
                case 'percent':
                case 'phone':
                case 'textarea':
                    control.input.val(value);
                    break;
                case 'date':
                case 'datetime':
                    let val;
                    if (PJQ.helpers.objectHelpers.refinedType(value) === 'date') {
                        val = value;
                    } else if (_.size(value) > 0) {
                        val = new Date(value);
                    } else {
                        val = null;
                    }
                    control.input.setValue(val);
                    break;
            }
        } else {
            this.renderField(field);
        }
    },
    fieldChanged: function (fieldId, value, triggerEvent = true) {
        let fieldValueObj = _.findWhere(this.options.fieldValues, {id: fieldId}),
            field = this.collection.get(fieldId);
        if (field.get('fieldType') === 'CHOICE' && !field.get('isMultipleChoice')) {
            value = parseInt(value);
        }
        if (fieldValueObj == null) {
            fieldValueObj = {
                id: fieldId,
                fieldNumber: field.get('fieldNumber'),
                value: value
            };
            this.options.fieldValues.push(fieldValueObj);
        } else {
            fieldValueObj.value = value;
        }

        let changedObj = _.findWhere(this.changedValues, {id: fieldId});
        if (changedObj != null) {
            changedObj.value = value;
        } else {
            this.changedValues.push(fieldValueObj);
        }
        if (typeof this.options.onChange === 'function' && triggerEvent) {
            this.options.onChange(fieldId, value);
        }
    },
    getValues: function () {
        return this.options.fieldValues;
    },
    getChanged: function () {
        return this.changedValues;
    },
    validate: function () {
        let isValid = true;
        _.each(this.collection.models, _.bind(function (field) {
            if ((!this.options.isAdmin && !field.get('isRequired')) || (this.options.isAdmin && field.get('isRequiredAdmin') != null && !field.get('isRequiredAdmin')) || (this.options.isAdmin && !field.get('isRequired') && field.get('isRequiredAdmin') == null))
                return;
            else if (!this.options.isAdmin && field.get('isAdminEdit')) {
                return;
            }

            _.each(this.customFieldControls, _.bind(function (control) {
                let customFieldId = control.id,
                    input = control.input;
                if (customFieldId === field.id) {
                    switch (field.get('fieldType').toLowerCase()) {
                        case 'text':
                        case 'int':
                        case 'percent':
                        case 'phone':
                        case 'textarea':
                            PJQ.helpers.inputHelpers.setInputError(input, true);
                            if (input.val().trim().length === 0) {
                                PJQ.helpers.inputHelpers.setInputError(input, false);
                                isValid = false;
                            }
                            break;
                        case 'money':
                            PJQ.helpers.inputHelpers.setInputError(input, true);
                            if (input.val().trim().length === 0 || parseInt(input.val().trim()) === 0) {
                                PJQ.helpers.inputHelpers.setInputError(input, false);
                                isValid = false;
                            }
                            break;
                        case 'bool':
                            input.hideError();
                            if (_.size(input.getValue()) === 0) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'date':
                        case 'datetime':
                            input.hideError();
                            if (input.getValue() === undefined || input.getValue() == null) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'choice':
                            input.hideError();
                            if (input.options.isMultiple ? (_.size(input.getValue()) === 0) : (!input.getValue() || input.getValue().length === 0)) {
                                input.showError();
                                isValid = false;
                            }
                            break;
                        case 'contact':
                            if (!input.validate())
                                isValid = false;
                            break;
                        case 'upload':
                            input.clearError();
                            if (!input.options.collection || input.options.collection.length == 0) {
                                input.showError("File Upload Required");
                                isValid = false;
                            }
                            break;
                    }
                }
            }, this));
        }, this));

        return isValid;
    }
});

PJQ.views.customFields.CustomFieldsSearchForm = PJQ.views.customFields.CustomFieldsForm.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Form'),
        subTemplates: {
            field: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Search-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Custom-Fields-Search-Form-Field-Input')
        },
        applyDefaults: false
    },
    afterRender: function () {
        _.each(this.collection.models, function (field) {
            let $field = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.field, {
                model: field,
                fieldValues: this.options.fieldValues,
                subTemplates: this.options.subTemplates
            });
            this.$('.custom-fields').append($field);
        }, this);
        this.attachFormEvents();
    },
    attachFormEvents: function () {
        let self = this;
        this.customFieldControls = [];

        this.$('.custom-field.input-text[data-p-bind],.custom-field.input-dollars-full[data-p-bind],.custom-field.input-numeric[data-p-bind],.custom-field.input-phone[data-p-bind],.custom-field.input-textarea[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                mask = input.data('mask');
            if (_.size(mask) > 0) {
                input.inputmask(mask, {
                    placeholder: ''
                });
            } else if (input.hasClass('input-dollars-full')) {
                PJQ.helpers.inputHelpers.inputMaskCurrency(input, 2);
            } else if (input.hasClass('input-numeric')) {
                PJQ.helpers.inputHelpers.inputMaskInteger(input);
            } else if (input.hasClass('input-phone')) {
                PJQ.helpers.inputHelpers.inputMaskPhone(input);
            }

            self.customFieldControls.push({
                id: customFieldId,
                input: input,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-percent[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex');

            self.customFieldControls.push({
                id: customFieldId,
                input: input,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-select[data-p-bind],.custom-field.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                control = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state'),
                    onChange: function (value) {
                        if (input.hasClass('input-bool'))
                            value = value.toLowerCase() === 'true';

                        self.fieldChanged(customFieldId, valueIndex, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-date[data-p-bind],.custom-field.input-date-time[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                isDateTime = input.hasClass('input-date-time'),
                control = new PJQ.inputs.Datepicker({
                    el: input,
                    isUTC: false,
                    datepickerOptions: {
                        format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                    },
                    onChange: function (value) {
                        if (!isDateTime)
                            value = value ? PJQ.helpers.dateHelpers.getDateString(value, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                        else
                            value = value ? value.toISOString() : null;
                        self.fieldChanged(customFieldId, valueIndex, value);
                    }
                });

            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        this.$('.custom-field.input-contact[data-p-bind]').each(function () {
            let input = $(this),
                customFieldId = input.data('pBind'),
                valueIndex = input.data('valueIndex'),
                fieldValue = _.find(self.options.fieldValues, function (fieldValue) {
                    return fieldValue.id === customFieldId;
                });

            let value = fieldValue.value,
                isMultipleChoice = input.data('multipleChoice');
            if (isMultipleChoice) {
                value = new PJQ.collections.contacts.Contacts(value).models;
            } else if (value != null) {
                value = new PJQ.models.contacts.Contact(value);
            }

            let control = new PJQ.views.contacts.ContactsSelectInput({
                el: input,
                context: PJQ.constants.contacts.contexts.CONTACTS,
                selectedContact: value,
                isSingleChoice: !isMultipleChoice,
                canEdit: self.options.canEdit,
                emptyNotice: "No Contact Selected",
                onChange: function (selectedContacts) {
                    self.fieldChanged(customFieldId, valueIndex, selectedContacts);
                }
            });

            self.customFieldControls.push([customFieldId, valueIndex, control]);
            self.customFieldControls.push({
                id: customFieldId,
                input: control,
                index: valueIndex
            });
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, null, {
            watchElements: [
                'input.custom-field',
                'textarea.custom-field'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                if (changeEl.hasClass('input-percent') || changeEl.hasClass('input-date-time') || changeEl.hasClass('input-date'))
                    return;

                let valueIndex = parseInt($(changeEl).data('valueIndex'));
                this.fieldChanged(parseInt(attribute), valueIndex, value);
            }, this)
        });
    },
    fieldChanged: function (fieldId, valueIndex, value) {
        let fieldValueObj = _.findWhere(this.options.fieldValues, {id: fieldId});
        if (fieldValueObj == null) {
            let field = this.collection.get(fieldId);

            fieldValueObj = {
                id: fieldId,
                fieldNumber: field.get('fieldNumber'),
                value: valueIndex === 1 ? value : null,
                value2: valueIndex === 2 ? value : null
            };
            this.options.fieldValues.push(fieldValueObj);
        } else {
            if (valueIndex === 1)
                fieldValueObj.value = value;
            else
                fieldValueObj.value2 = value;
        }

        let changedObj = _.findWhere(this.changedValues, {id: fieldId});
        if (changedObj != null) {
            changedObj.value = valueIndex === 1 ? value : changedObj.value;
            changedObj.value2 = valueIndex === 2 ? value : changedObj.value2;
        } else {
            this.changedValues.push(fieldValueObj);
        }

        if (!fieldValueObj.value && !fieldValueObj.value2) {
            this.options.fieldValues = _.filter(this.options.fieldValues, function (fieldValue) {
                return fieldValue.id !== fieldId
            });
            this.changedValues = _.filter(this.changedValues, function (fieldValue) {
                return fieldValue.id !== fieldId
            });
        }

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(fieldId, value);
        }
    },
    clearFieldValues: function () {
        this.options.fieldValues = [];
        this.changedValues = [];
        this.render();
    },
    setValues: function (fieldValues) {
        this.options.fieldValues = fieldValues;
        this.changedValues = [];
        this.render();
    },
    validateSearch: function () {
        let isValid = true;
        _.each(this.collection.models, _.bind(function (field) {
            _.each(this.customFieldControls, _.bind(function (control) {
                let customFieldId = control.id,
                    valueIndex = control.index,
                    input = control.input,
                    input2 = null;

                if (valueIndex === 1) {

                    if (customFieldId === field.id) {
                        switch (field.get('fieldType').toLowerCase()) {
                            case 'bool':
                            case 'choice':
                            case 'contact':
                            case 'percent':
                            case 'phone':
                            case 'text':
                            case 'textarea':
                                // no validation needed
                                break;
                            case 'int':
                            case 'money':
                                // get 2nd control
                                input2 = _.filter(this.customFieldControls, function (control2) {
                                    return (control2.id === field.id && control2.index === 2);
                                })[0].input;

                                // clear error state for both
                                PJQ.helpers.inputHelpers.setInputError(input, true);
                                PJQ.helpers.inputHelpers.setInputError(input2, true);

                                // if value empty, set error on it
                                if (_.size(input.val()) === 0 && _.size(input2.val()) > 0) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input, false);
                                }

                                // if value2 empty, set error on it
                                if (_.size(input2.val()) === 0 && _.size(input.val()) > 0) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input2, false);
                                }

                                // if value > value2 set error on both
                                if (_.size(input.val()) > 0 && _.size(input2.val()) > 0 && parseInt(input.val()) > parseInt(input2.val())) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input, false);
                                    PJQ.helpers.inputHelpers.setInputError(input2, false);
                                }
                                break;
                            case 'date':
                            case 'datetime':
                                // get 2nd control
                                input2 = _.filter(this.customFieldControls, function (control2) {
                                    return (control2.id === field.id && control2.index === 2);
                                })[0].input;

                                // clear error state for both
                                PJQ.helpers.inputHelpers.setInputError(input.$el, true);
                                PJQ.helpers.inputHelpers.setInputError(input2.$el, true);

                                // if value empty, set error on it
                                if (!input.getValue() && input2.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input.$el, false);
                                }

                                // if value2 empty, set error on it
                                if (!input2.getValue() && input.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input2.$el, false);
                                }

                                // if value > value2 set error on both
                                if (input.getValue() && input2.getValue() && input.getValue() > input2.getValue()) {
                                    isValid = false;
                                    PJQ.helpers.inputHelpers.setInputError(input.$el, false);
                                    PJQ.helpers.inputHelpers.setInputError(input2.$el, false);
                                }
                                break;
                        }
                    }
                }
            }, this));
        }, this));

        return isValid;
    }
});

PJQ.views.customFields.CustomFieldChoicesEditor = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Custom-Field-Choices-Editor'),
        choices: [],
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .add-custom-field-choice-button": "addChoice",
        "click .delete-custom-field-choice-button": "deleteChoice",
        "change .custom-field-choice-value": "choiceChanged",
        "click .custom-field-choices-cancel": "cancel",
        "click .custom-field-choices-save": "save"
    },
    beforeRender: function () {
        _.each(this.collection.models, function (model) {
            model.oldAttributes = _.clone(model.attributes);
        });

        this.renderData = {
            models: _.filter(this.collection.models, function (model) {
                return !model.get("isDeleted")
            })
        };
    },
    afterRender: function () {
        this.$('.custom-field-choices-table').DataTable({
            "ordering": false
        });
        this.$('.custom-field-choices-table').sortable({
            items: 'tr',
            connectWith: 'tr',
            update: _.bind(this.setSortOrder, this)
        });
    },
    setSortOrder: function () {
        let self = this;
        this.$('.custom-field-choices-table').find('tbody>tr[data-cid]').each(function (index) {
            let cid = $(this).data('cid'),
                choice = self.collection.get({cid: cid});
            choice.set('sortOrder', index + 1);
        });
    },
    addChoice: function () {
        this.collection.add(new PJQ.models.customFields.CustomFieldChoice({
            value: '',
            sortOrder: this.collection.models.length + 1
        }));
        this.render();
    },
    choiceChanged: function (e) {
        let cid = $(e.currentTarget).closest('tr').data('cid'),
            choice = this.collection.get({cid: cid});
        choice.set('value', $(e.currentTarget).val());
    },
    deleteChoice: function (e) {
        let cid = $(e.currentTarget).closest('tr').data('cid'),
            choice = this.collection.get({cid: cid});
        if (choice.isNew())
            this.collection.remove(choice);
        else
            choice.set('isDeleted', true);
        this.render();
    },
    cancel: function () {
        _.each(this.collection.models, function (model) {
            model.attributes = _.clone(model.oldAttributes);
            model.oldAttributes = null;
        });
        this.options.onCancel(this.collection);
    },
    save: function () {
        this.options.onSave(this.collection);
    }
});
